var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71299 1.30711C9.99324 1.19103 10.3158 1.25519 10.5303 1.46969L14.5303 5.46969C14.8232 5.76259 14.8232 6.23746 14.5303 6.53035L10.5303 10.5304C10.3158 10.7449 9.99324 10.809 9.71299 10.6929C9.43273 10.5768 9.25 10.3034 9.25 10V6.75002H4C3.30964 6.75002 2.75 7.30967 2.75 8.00002V14.5C2.75 14.9142 2.41421 15.25 2 15.25C1.58579 15.25 1.25 14.9142 1.25 14.5V8.00002C1.25 6.48124 2.48122 5.25002 4 5.25002H9.25V2.00002C9.25 1.69668 9.43273 1.4232 9.71299 1.30711Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 5.25C17.3001 5.25 16.9643 5.58579 16.9643 6C16.9643 6.41421 17.3001 6.75 17.7143 6.75H20C20.6904 6.75 21.25 7.30964 21.25 8V9.71429C21.25 10.1285 21.5858 10.4643 22 10.4643C22.4142 10.4643 22.75 10.1285 22.75 9.71429V8C22.75 6.48122 21.5188 5.25 20 5.25H17.7143Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12.2857C22.75 11.8715 22.4142 11.5357 22 11.5357C21.5858 11.5357 21.25 11.8715 21.25 12.2857V15.7143C21.25 16.1285 21.5858 16.4643 22 16.4643C22.4142 16.4643 22.75 16.1285 22.75 15.7143V12.2857Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 18.2857C2.75 17.8715 2.41421 17.5357 2 17.5357C1.58579 17.5357 1.25 17.8715 1.25 18.2857V20C1.25 21.5188 2.48122 22.75 4 22.75H6.28571C6.69993 22.75 7.03571 22.4142 7.03571 22C7.03571 21.5858 6.69993 21.25 6.28571 21.25H4C3.30964 21.25 2.75 20.6904 2.75 20V18.2857Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18.2857C22.75 17.8715 22.4142 17.5357 22 17.5357C21.5858 17.5357 21.25 17.8715 21.25 18.2857V20C21.25 20.6904 20.6904 21.25 20 21.25H17.7143C17.3001 21.25 16.9643 21.5858 16.9643 22C16.9643 22.4142 17.3001 22.75 17.7143 22.75H20C21.5188 22.75 22.75 21.5188 22.75 20V18.2857Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 21.25C9.30007 21.25 8.96429 21.5858 8.96429 22C8.96429 22.4142 9.30007 22.75 9.71429 22.75H14.2857C14.6999 22.75 15.0357 22.4142 15.0357 22C15.0357 21.5858 14.6999 21.25 14.2857 21.25H9.71429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotion);
export default __webpack_public_path__ + "static/media/motion.64d1994932d5c43a18367d2d25f08f36.svg";
export { ForwardRef as ReactComponent };